import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'vx-ui-components';
import styles from './styles.css';

const GrowlerComponent = ({ status, message, action }) => {
  const stylesGrowler = {
    opacity: status !== 'show' ? 1 : 1,
    marginTop: status !== 'show' ? -56 : 0,
  };

  return (
    <div className={styles.error} style={stylesGrowler}>
      {message}
      {action !== undefined && 
        <button
          onClick={this.toggleWidgetList}
          style={{
            border: 'none',
            cursor: 'pointer',
            position: 'absolute',
            right: '16px',
            top: '16px',
            background: 'transparent',
          }}
        >
          <Icon stroke="#fff" name="menu_close"/>
        </button>
      }
    </div>
  );
};

GrowlerComponent.propTypes = {
  message: PropTypes.string,
  status: PropTypes.string,
};

export default GrowlerComponent;



// WEBPACK FOOTER //
// ./src/containers/Notification/GrowlerComponent.js